import React, { useState, Fragment, useEffect } from "react";
import { Typography, CardMedia, Box } from "@material-ui/core";
import { useLocation, useNavigate } from "react-router-dom";
import ModalContainer from "./ModalContainer";
import { isIpad } from "../constant/StaffOnboardState";
import { makeStyles } from "@material-ui/core/styles";
import { useGlobalData } from "../constant/GlobalDataContext";
import "../styles/styles.css";

type Props = {
  isBack: boolean;
  goBack?: () => void;
  isNeedPW?: boolean;
  step?: number;
};

const NavBar = (props: Props) => {
  const { isBack, goBack, isNeedPW, step } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [isNavOpenPw, setIsNavOpenPw] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const ShowLogOut = () => {
    if (!isIpad()) return true;
    if (isIpad() && location?.pathname == "/p/main" || location?.pathname == "/p/main/") 
      return true;
    return false;
  };

  return (
    <Fragment>
      <div
        className={"noPrint"}
        style={{
          display: "flex",
          width: "100%",
          height: "5rem",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <ModalContainer
          type={isNeedPW || isNavOpenPw ? "isNeedPW" : "logout"}
          setOpen={setOpen}
          open={open}
          goBack={() => {
            if (
              (location.pathname === "/p/main/documentLists" ||
                location.pathname === "/p/StaffInfoFormUnsigned") &&
              isIpad()
            ) {
              navigate("/main");
            } else if (
              (location.pathname ===
                "/main/documentLists/reference_authorization" ||
                location.pathname === "/main/documentLists/handBook" ||
                location.pathname ===
                  "/main/documentLists/personal_information") &&
              isIpad()
            ) {
              navigate("/main/documentLists", {
                state: {
                  staffId: location?.state?.docInfo?.staff_id,
                },
              });
            } else {
              navigate(-1);
            }
          }}
        />
        {isBack && (
          <Fragment>
            <div
              onClick={() => {
                if (isNeedPW) {
                  setOpen(true);
                } else {
                  if (goBack !== undefined) {
                    goBack();
                  } else {
                    navigate(-1);
                    
                  }
                }
              }}
              style={{
                display: "flex",
                cursor: "pointer",
              }}
            >
              <CardMedia
                component="img"
                image={require("../icons/goBack.png")}
                alt=""
                className={classes.media}
              />
              <Typography variant="h5" className={classes.title}>
                返回上一頁
              </Typography>
            </div>
          </Fragment>
        )}
        {!isBack && (
          <Typography variant="h5" className={classes.title}>
            員工文件系統
            {!!process.env.REACT_APP_SUB_TITLE &&
              `(${process.env.REACT_APP_SUB_TITLE})`}
          </Typography>
        )}

        {ShowLogOut() && (
          <Fragment>
            <Box
              onClick={() => {
                setOpen(true);
              }}
              style={{
                display: "flex",
                cursor: "pointer",
              }}
            >
              <div style={{ paddingRight: "40px", display: "flex" }}>
                <CardMedia
                  component="img"
                  image={require("../icons/userId.png")}
                  alt=""
                  className={classes.media}
                />
                <Typography variant="h5" className={classes.title}>
                  {user?.data?.username}
                </Typography>
              </div>
              <CardMedia
                component="img"
                image={require("../icons/logout.png")}
                alt=""
                className={classes.media}
              />
              <Typography variant="h5" className={classes.title}>
                登出
              </Typography>
            </Box>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default NavBar;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
  },
  title: { color: "#454C96", fontWeight: 500 },
  container: {
    // display: "flex",
    height: "100vh",
    borderRadius: "10rem",
  },

  input: {
    margin: theme.spacing(1, 0),
  },
  button: {
    margin: theme.spacing(1, 0),
    width: "50%",
  },
  media: {
    height: "20px",
    margin: "5px",
    [`&.MuiCardMedia-img`]: {
      objectFit: "contain",
      width: "20px",
    },
  },
}));
